import React from 'react';
import { steps } from '../../data/site';
import { SectionHeading } from '../ui/SectionHeading';
import { useBrand } from '../../contexts/BrandContext';
export function Steps() {
  const {
    text
  } = useBrand();
  return <section className="bg-cream" data-id="element-145" data-mp="pb6zkcgjulpg">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-146" data-mp="p82mepl3wfmn">
        <SectionHeading eyebrow="How it works" title="Four steps, and you see the price before the third one." intro="Nothing ships and nothing gets charged until a doctor has read your labs and you have said yes to the plan." data-id="element-147" data-mp="tck0q98p60q1" />

        <ol className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-148" data-mp="1816kcn5cxen2">
          {steps.map((step, index) => <li key={step.label} className="rounded-brand border border-ink/10 bg-cream-light p-6" data-id="element-149" data-mp="1cyouggv41zwn" data-mpi={index}>
              <div className="flex items-baseline justify-between" data-id="element-150" data-mp="3spugqamptbo0">
                <span className="font-serif text-2xl font-bold text-brick" data-id="element-151" data-mp="1kbb9pbay8my">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="text-[0.625rem] uppercase tracking-label text-ink-muted" data-id="element-152" data-mp="30oqs8hkz9d1z">
                  {step.duration}
                </span>
              </div>
              <h3 className="mt-5 font-serif text-lg font-semibold leading-snug text-ink" data-id="element-153" data-mp="3amy3qkwhz2wl">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-soft" data-id="element-154" data-mp="35ma7nktevvvi">{text(step.detail)}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}